export enum ChatTypes {
  operations = "OPERATIONS",
  comment = "COMMENT",
  directMessages = "DIRECT_MESSAGES",
}

export enum IconTypes {
  close = "close",
}
